import { render } from "./PopupPasswordEdit.vue?vue&type=template&id=178493fb"
import script from "./PopupPasswordEdit.vue?vue&type=script&lang=js"
export * from "./PopupPasswordEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\Carryglobal\\GlobalLinkVIPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__